module.exports = __webpack_public_path__ + "img/stonedPlaceholder.0539cb9f.png";